import gql from "graphql-tag";

export const OC_GET_PERMIT = gql`
  query permit {
    permit {
      _id
      requestedAt
      permittedAt
      permittedBy
      cancelledAt
    }
  }
`;
